import { render, staticRenderFns } from "./model.card.vue?vue&type=template&id=32a9b9bb&"
import script from "./model.card.vue?vue&type=script&lang=ts&"
export * from "./model.card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports